module.exports = __webpack_public_path__ + "img/md-dark-deeppurple.b6e4f4b3.svg";